<template>
<div>
  <div style="display: block;margin-top: 90px" >
    <img src="../assets/images/shop2.png"  width="100%" />
  </div>
  <section shop-area>
      <el-row >
        <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
         <!-- Single Widget Area -->
          <div class="single-widget-area" >
            <!-- Title -->
            <h5 class="widget-title"  style="color: darkslateblue;"><span class = "iconfont iconfangzidaiquan" style="font-size: 1.1em"></span> 分类目录</h5>
            <!-- Cata List -->
            <ul class="cata-list shop-page" >
              <li><a @click="handleSelect(1)">所有产品 ({{this.products.length}})</a></li>
              <li><a @click="handleSelect(2)">专业产品 ({{this.allProfession.length}})</a></li>
              <li><a @click="handleSelect(3)">多种维生素 ({{this.allVitamin.length}})</a></li>
              <li><a @click="handleSelect(4)">能源饮料 ({{this.allEnergyWater.length}})</a></li>
              <li><a @click="handleSelect(5)">未分类 ({{this.others.length}})</a></li>
            </ul>
            <div style="margin:0 auto "><img style="height: 200px;width: 200px;" src="../assets/images/qrcode.jpg"/> </div>
            <p>购买产品请具体咨询工作人员，并扫码支付。</p>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18" style="margin-left: -10%">
          <el-row :gutter="20" style="padding: 5% 5%">
            <!-- 单个商品控制 -->
            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8" v-for="(item,index) in tmpProduct" :key="index">
              <div class="single-product-area mb-50">
                <!-- Product Thumbnail -->
                <div class="product-thumbnail">
                  <!-- <img src="../assets/images/product/Arnica-300x300.jpg" > -->
                  <!-- <img :src = "'../assets/images/product/' + item.url" alt="" > -->
                  <img :src = "item.url" alt="" >
                  <!-- Product Tags  定义产品特点，hot或者new  -->
                  <!--
                  <span class="product-tags">Hot</span>
                  -->
                  <!-- Product Meta Data -->
                  <!--
                  <div class="product-meta-data">
                    <a href="#" data-toggle="tooltip" data-placement="top" title="Favourite"><i class="icon_heart_alt"></i></a>
                    <a href="#" data-toggle="tooltip" data-placement="top" title="Add To Cart"><i class="icon_cart_alt"></i></a>
                    <a href="#" data-toggle="tooltip" data-placement="top" title="Compare"><i class="arrow_left-right_alt"></i></a>
                  </div>
                  -->
                </div>
                <!-- Product Description &nbsp&nbsp&nbsp&nbsp -->
                <div class="product-desc text-center pt-4">
                  <a @click="handleProduct(index)" class="product-title">{{item.title}}  <span  class="price" style="padding-right: 10px">{{item.price}}</span></a>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    <el-row style="margin: -20px 0 50px 0"><el-col>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size=pageSize
        :total=totalSize
        @current-change = refreshShop>
      </el-pagination>
    </el-col></el-row>
  </section>
  <el-dialog
    title="产品介绍"
    :visible.sync="dialogVisible"
    width="900px"
    custom-class="el-dialog"
    >
    <div style="height: 360px">
      <div style="display:flex; width: 840px;height: 350px;float: left;">
        <div style="width: 300px;"><img :src= "tmpProduct[currentIdx].url" /></div>
        <div style="width: 530px; margin-left: 20px;margin-top:-20px; text-align: left">
          <h2>{{ tmpProduct[currentIdx].title }}</h2>
          <p style="font-size: 16px;letter-spacing: 1px" v-html="tmpProduct[currentIdx].content"></p>
          <span><strong>产品描述：</strong></span><br><p style="font-size: 16px;letter-spacing: 1px" v-html="tmpProduct[currentIdx].desc"></p>
          <p style="font-size: 16px;letter-spacing: 1px" v-html="tmpProduct[currentIdx].composition"></p>
        </div>
      </div>
      <!--
      <div style="display:flex;float: left ;margin:0 auto "><img style="height: 100px;width: 100px;" src="../assets/images/qrcode.jpg"/> </div>
      -->
    </div>
    <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
// import '../assets/icon/iconfont.css'
import productsList from './product/products.json'
import {$getJson} from '../json/http'

export default {
  name: 'shop',
  data () {
    return {
      products: '../../static/product/Balance-300x300.jpg',
      pageSize: 9,
      totalSize: 0,
      allProfession: [],
      allVitamin: [],
      allEnergyWater: [],
      others: [],
      tmpProduct: [
        {
          url: ''
        }
      ],
      dialogVisible: false,
      currentIdx: 0,
      productArray: null
    }
  },
  methods: {
    getShopNum (productArray) {
      // alert(this.products.length)
      this.totalSize = productArray.length
    },
    refreshShop (curPage) {
      // alert(curPage)
      this.tmpProduct = []
      let idx = 0
      let iBegin = (curPage - 1) * this.pageSize
      while (idx < this.pageSize) {
        if (iBegin < this.productArray.length) {
          this.tmpProduct.push(this.productArray[iBegin])
        } else {
          break
        }
        idx++
        iBegin++
      }
    },
    handleProduct (index) {
      this.currentIdx = index
      this.dialogVisible = true
    },
    handleSelect (index) {
      switch (index) {
        case 1: {
          this.getShopNum(this.products)
          this.productArray = this.products
          this.refreshShop(1)
          break
        }
        case 2: {
          this.getShopNum(this.allProfession)
          this.productArray = this.allProfession
          this.refreshShop(1)
          break
        }
        case 3: {
          this.getShopNum(this.allVitamin)
          this.productArray = this.allVitamin
          this.refreshShop(1)
          break
        }
        case 4: {
          this.getShopNum(this.allEnergyWater)
          this.productArray = this.allEnergyWater
          this.refreshShop(1)
          break
        }
        case 5: {
          this.getShopNum(this.others)
          this.productArray = this.others
          this.refreshShop(1)
          break
        }
      }
    }
  },

  mounted () {
    this.products = productsList.productDetail
    let idx = 0
    // ------------------------------------------
    // vitamin ; water ; professtion ;
    for (idx = 0; idx < this.products.length; idx++) {
      switch (this.products[idx].type) {
        case 'vitamin': {
          this.allVitamin.push(this.products[idx])
          break
        }
        case 'profession': {
          this.allProfession.push(this.products[idx])
          break
        }
        case 'water': {
          this.allEnergyWater.push(this.products[idx])
          break
        }
        default: {
          this.others.push(this.products[idx])
          break
        }
      }
    }
    // 分页处理
    this.getShopNum(this.products)
    this.productArray = this.products
    this.refreshShop(1)
    // 采用封装的axios调用json文件
    // 1)axios直接调用
    this.axios.get('../../static/productJson/products.json').then(
      res => {
        // console.log('json1调用')
        // console.log(res.data.productDetail)
      }
    )
    // 2.通过promise封装
    $getJson('../../static/productJson/products.json').then(
      res => {
        // console.log('json调用')
        // console.log(res)
      }
    )
  }
}
</script>

<style scoped>
  .el-row{
    left: 5%;
    top: 5%;
    // adding-left: 5%;
    // padding-right: 5%;
  }
  .single-widget-area {
    width: 50%;
    padding-top:30px;
    margin: 0 auto;
    position: relative;
    letter-spacing: 2px;
    //border: 1px solid darkslateblue;
    z-index: 1;
    //text-align: left;
    margin-bottom: 80px; }
  .single-widget-area .widget-title {
    margin-bottom: 30px;
    text-align: left;
    font-size: 22px;
    font-weight: 700;
    padding-left: 5px;
    text-transform: capitalize;
  }
  .cata-list {
    position: relative;
    list-style: none;
    text-align: left;
    z-index: 1; }
  .cata-list li a {
    display: block;
    font-size: 16px;
    padding: 10px 0;
    border-bottom: 1px solid #e1e1e1;
    color: #707070;
    font-weight: 400; }
  .cata-list li a:hover, .cata-list li a:focus {
    color: #77b122; }
  .cata-list li:first-child a {
    padding-top: 0; }
  .cata-list li:last-child a {
    border-bottom: none;
    padding-bottom: 0; }
  .cata-list.shop-page li a {
    font-size: 14px;
    padding: 5px 0;
    border-bottom: none; }
  .single-product-area {
    position: relative;
    z-index: 1; }
  .single-product-area .product-thumbnail {
    position: relative;
    z-index: 1; }
  .single-product-area .product-thumbnail img {
    width: 100%; }
  .single-product-area .product-thumbnail .product-tags {
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 9;
    padding: 0 12px;
    border-radius: 3px;
    background-color: #23c39f;
    font-size: 12px;
    text-transform: uppercase;
    line-height: 20px;
    height: 20px;
    display: inline-block;
    color: #ffffff; }
  .single-product-area .product-thumbnail .product-meta-data {
    -webkit-transition-duration: 500ms;
    -o-transition-duration: 500ms;
    transition-duration: 500ms;
    position: absolute;
    width: 100%;
    text-align: center;
    bottom: 30px;
    opacity: 0;
    visibility: hidden; }
  .single-product-area .product-thumbnail .product-meta-data a {
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.2);
    text-align: center;
    line-height: 42px;
    margin: 0 5px;
    font-size: 16px; }
  .single-product-area .product-thumbnail .product-meta-data a:focus, .single-product-area .product-thumbnail .product-meta-data a:hover {
    background-color: #77b122;
    color: #ffffff; }
  .single-product-area .product-desc {
    position: relative;
    z-index: 1; }
  .single-product-area .product-desc .product-title {
    font-size: 18px;
    margin-bottom: 5px;
    //font-weight: 400;
    display: block; }
  .single-product-area .product-desc a{
    text-decoration: none; }
  .single-product-area .product-desc .product-title:focus, .single-product-area .product-desc .product-title:hover {
    color: #77b122; }
  .single-product-area .product-desc .price {
    margin-bottom: 0;
    font-size: 18px; }
  .single-product-area .product-desc .price span {
    text-decoration: line-through;
    color: #707070;
    font-size: 18px;
    //font-weight: 400; }
  .single-product-area:focus .product-meta-data, .single-product-area:hover .product-meta-data {
    opacity: 1;
    visibility: visible; }
  .mb-50{
    margin-bottom: 50px;
  }
  .pt-4{
    padding-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop.vue